import React from 'react'
import './blogItem.scss'

const BlogItem = (props) => {
  const { title, description, url, favoriteURL, favoriteAnchor,  } = props
  return (
    <div>
      <h3><span className="title">{title}</span></h3>
      {description && <p className="description">{description}</p>}
      <div className="urlContainer">
        {favoriteURL && favoriteAnchor ? (
          <p>Favorite article: <a href={favoriteURL} target="_blank" rel="nofollow">{favoriteAnchor}</a></p>
        ) : ""}
        {url && !favoriteURL ? (
          <p>Website: <a href={url} target="_blank" rel="nofollow">{url}</a></p>
        ) : ""}
      </div>
    </div>
  )
}

export default BlogItem
